import * as firebase from "firebase/app"
import "firebase/auth"
import { store } from "../../src/store"
import { FIREBASE_STATE_KEYS } from "./helpers"
import {
  ToastMessage,
  NOTIFICATION_TYPES,
} from "../components/Notification/Notifications"
import { LOGIN_FAILED } from "../constants/notificationMsg"

import _ from "../../src/utils/lodashUtils"

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DB_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MSG_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
}

// Initialize Firebase
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

export class FirebaseService {
  static FIREBASE_DB = firebase.database()
  static AUTH = firebase.auth()

  static getDefaultPath() {
    const dateId = _.get(store.getState(), "invitePeople.partnerDetails.uuid")
    if (dateId === undefined) {
      return undefined
    }
    return `${dateId}/`
  }

  static getDatabaseInstance() {
    return FirebaseService.FIREBASE_DB
  }

  static getAuthInstance() {
    return FirebaseService.AUTH
  }

  static notifyPartnerBack({ chatSpaceName, partnerActiveScreen }) {
    const partnerId = _.get(store.getState(), "auth.partner.uuid")
    const path = `${this.getDefaultPath()}${partnerId}/notifyBack`
    this.patch(
      {
        chatSpaceName,
        partnerActiveScreen,
      },
      path
    )
  }

  static getDatabaseRef(path = FirebaseService.getDefaultPath()) {
    return FirebaseService.getDatabaseInstance().ref(path)
  }

  static setUserPresence(isOnline) {
    if (isOnline) {
      FirebaseService.getDatabaseInstance().goOnline()
    } else {
      FirebaseService.getDatabaseInstance().goOffline()
      //Todo disconnect twilio channel
      // deleteChannel()
    }
  }
  static async addRemoveItem(item, added, updateFirebase = true) {
    const userId = _.get(store.getState(), "auth.user.uuid")
    const path = `${this.getDefaultPath()}${userId}/cartList`
    const cart = (await this.read(path)) || []
    if (added) {
      cart.push(item)
    } else {
      const key = cart.indexOf(
        (cartItem) => cartItem.item_key === item.item_key
      )
      cart.splice(key, 1)
    }
    if (updateFirebase) {
      this.patch(
        {
          [FIREBASE_STATE_KEYS.CART_LIST]: cart,
        },
        `${this.getDefaultPath()}${userId}/`
      )
    }
    return cart
  }
  static setOrderCombined(status) {
    this.patch(
      {
        [FIREBASE_STATE_KEYS.IS_ORDER_COMBINED]: status,
      },
      this.getDefaultPath()
    )
  }
  static setActiveRoute(route) {
    const userId = _.get(store.getState(), "auth.user.uuid")
    this.patch(
      {
        [FIREBASE_STATE_KEYS.ACTIVE_ROUTE]: route,
      },
      `${this.getDefaultPath()}${userId}/`
    )
  }
  static setInviteStatus(status, customDateId = null) {
    const dateId = _.get(
      store.getState(),
      "invitePeople.partnerDetails.uuid",
      customDateId
    )
    const path = FirebaseService.getDatabaseRef(`${dateId}/`)
    this.patch(
      {
        [FIREBASE_STATE_KEYS.STATUS]: status,
      },
      path
    )
  }

  static async authenticateWithToken(token) {
    if (token) {
      try {
        await FirebaseService.AUTH.signInWithCustomToken(token)
      } catch (error) {
        console.error(error.code, error.message, error)
        ToastMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: LOGIN_FAILED,
        })
      }
    }
  }

  static async getAuthenticatedUser() {
    return FirebaseService.getAuthInstance().currentUser
  }

  // overrites exisiting data at path.
  static async write(newState, path = FirebaseService.getDefaultPath()) {
    try {
      await FirebaseService.getDatabaseRef(path).set(newState)
      return await FirebaseService.read(path)
    } catch (error) {
      // Handle permission denied error
      console.error("WRITE permission denied error", error)
    }
  }

  // deletes key at the path
  static async delete(path) {
    try {
      return await FirebaseService.getDatabaseRef(path).remove()
    } catch (error) {
      // Handle permission denied error
      console.error("DELETE permission denied error", error)
    }
  }

  // patches existing data at path.
  static async patch(updates, path = FirebaseService.defaultPath) {
    try {
      await FirebaseService.getDatabaseRef(path).update(updates)
      return await FirebaseService.read(path)
    } catch (error) {
      // Handle permission denied error
      console.error("PATCH permission denied error", error)
    }
  }

  static async read(path = FirebaseService.defaultPath) {
    try {
      const snapshot = await FirebaseService.getDatabaseRef(path).once("value")
      const snapshotValue = snapshot.val()
      return snapshotValue
    } catch (error) {
      // Handle permission denied error
      console.error("READ permission denied error", error)
    }
  }
}
